import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChat1Line = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22H4C2.89543 22 2 21.1046 2 20V12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12V20H12C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM12 14C12.5523 14 13 14.4477 13 15C13 15.5128 12.614 15.9355 12.1166 15.9933L12 16H9C8.44772 16 8 15.5523 8 15C8 14.4872 8.38604 14.0645 8.88338 14.0067L9 14H12ZM15 10C15.5523 10 16 10.4477 16 11C16 11.5523 15.5523 12 15 12H9C8.44772 12 8 11.5523 8 11C8 10.4477 8.44772 10 9 10H15Z",
		fill: "currentColor"
	})
});
export default SvgChat1Line;
